<template>
  <div class="container">
    <div class="main-page">
      <page-header :headerConfig="headerConfig" @handleClickIocn="handleClickIocn" />

      <div class="main-nav">
        <div class="main-nav-item">
          <div class="sub-item sign-up" @click.stop="jumpToSign">
            <div class="sub-tit-wrap" v-if="this.currentSignup.id">
              报名信息
              <span class="en">Register[{{ this.currentSignup.status }}]</span>
            </div>
            <div class="sub-tit-wrap" v-else>
              注册报名
              <span class="en">Register[未报名]</span>
            </div>
            <div class="img-group">
              <img class="img" src="@/assets/img/signup.png" alt="" />
              <img class="icon" src="@/assets/img/signup-icon.png" alt="" />
            </div>
          </div>

          <div @click.stop="jumpTo('paper')" class="sub-item send">
            <div class="sub-tit-wrap">
              论文投稿
              <span class="en">Submission of papers</span>
            </div>
            <div class="img-group">
              <img class="img" src="@/assets/img/send.png" alt="" />
              <img class="icon" src="@/assets/img/send-icon.png" alt="" />
            </div>
          </div>
        </div>

        <div class="main-nav-item">
          <div @click.stop="jumpTo('pay')" class="sub-item pay">
            <div class="sub-tit-wrap">
              缴费管理
              <span class="en">Payment <br />management</span>
            </div>
            <div class="img-group">
              <img class="img" src="@/assets/img/pay.png" alt="" />
              <img class="icon" src="@/assets/img/pay-icon.png" alt="" />
            </div>
          </div>

          <div @click.stop="jumpToConferOnline" class="sub-item hy">
            <div class="sub-tit-wrap">
              会议直播
              <span class="en">Live <br />conference</span>
            </div>
            <div class="img-group">
              <img class="icon" src="@/assets/img/hy-icon.png" alt="" />
            </div>
          </div>

          <div @click.stop="jumpTo('visit')" class="sub-item bm">
            <div class="sub-tit-wrap">
              报名参观 <span class="en">Sign up</span>
            </div>
            <div class="img-group">
              <img class="icon" src="@/assets/img/bm-icon.png" alt="" />
            </div>
          </div>

          <div @click.stop="jumpToQuestionnaire" class="sub-item dc">
            <div class="sub-tit-wrap">
              调查问卷 <span class="en">Question</span>
            </div>
            <div class="img-group">
              <img class="icon" src="@/assets/img/dc-icon.png" alt="" />
            </div>
          </div>
        </div>

        <div class="main-nav-item">
          <div @click.stop="jumpTo('meet')" class="sub-item msg">
            <div class="sub-tit-wrap">
              会议信息
              <span class="en">Meeting<br />information</span>
            </div>
            <div class="img-group">
              <img class="img" src="@/assets/img/msg.png" alt="" />
              <img class="icon" src="@/assets/img/msg-icon.png" alt="" />
            </div>
          </div>

          <div @click.stop="jumpTo('signIn')" class="sub-item qd">
            <div class="sub-tit-wrap">
              签到入场
              <span class="en">Check in for <br />admission</span>
            </div>
            <div class="img-group">
              <img class="icon" src="@/assets/img/qd.png" alt="" />
            </div>
          </div>

          <div @click.stop="jumpTo('loginOut')" v-if="signinShow" class="sub-item out">
            <div class="sub-tit-wrap">
              退出登录 <span class="en">Sign out</span>
            </div>
            <div class="img-group">
              <img class="icon" src="@/assets/img/out.png" alt="" />
            </div>
          </div>

          <div @click.stop="jumpTo('login')" v-if="!signinShow" class="sub-item out">
            <div class="sub-tit-wrap">登录 <span class="en">Sign In</span></div>
            <div class="img-group">
              <img class="icon" src="@/assets/img/out.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageHeader from "@/components/header"
import pageTops from "./components/jumbotron.vue"
import store from "@/store"
import CurrentConferMixin from "@/mixin/CurrentConference"
import CurrentUserMixin from "@/mixin/CurrentUser"

export default {
  name: "HomePage",
  components: {
    pageHeader,
    pageTops,
  },
  mixins: [CurrentConferMixin, CurrentUserMixin],
  data() {
    return {
      headerConfig: {
        headerIcon: "city ct-cuowu",
        headerTitle: "中国土木工程学会",
        color: "#fff",
        bgColor: "#f9000d",
      },
    }
  },
  computed: {
    signinShow() {
      return this.$store.getters["auth/isTokenValid"]
    },
  },
  methods: {
    handleClickIocn() {
      window.close()
    },
    jumpTo(path) {
      if (path == "login") {
        this.$router.push({ name: path, params: { userId: "" } })
      } else if (path == "loginOut") {
        this.$store.dispatch("auth/logout").then(this.$message("退出登录成功！"))
      } else if (path == "meet") {
        this.$router.push({ name: path, params: { userId: "" } })
      } else {
        if (this.$store.getters["auth/isTokenValid"]) {
          this.$router.push({ name: path, params: { userId: "" } })
        } else {
          this.$message("请先登录")
        }
      }
    },
    jumpToSign() {
      if (this.$store.getters["auth/isTokenValid"]) {
        if (this.currentSignup.id) {
          this.$router.push({ name: "info" })
        } else {
          this.$router.push({ name: "signUp" })
        }
      } else {
        this.$message("请先登录")
      }
    },
    jumpToQuestionnaire() {
      if (this.$store.getters["auth/isTokenValid"]) {
        let opendate = new Date(this.currentConference.conferencedate)
        opendate.setHours(0, 0, 0, 0);
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        if (today >= opendate) {
          window.open(this.currentConference.surveyurl)
        } else {
          this.$message("会议召开后才能填写")
        }
      } else {
        this.$message("请先登录")
      }
    },
    jumpToConferOnline() {
      if (this.currentConference.liveurl) {
        window.open(this.currentConference.liveurl)
      } else {
        this.$message("尚未开始直播")
      }
    },
  },
}
</script>

<style lang="scss" scoped>
* {
  -webkit-tap-highlight-color: transparent;
}

.container {
  position: relative;
  width: 100%;
  min-height: 100vh;
}

.main-page {
  width: 100%;
  min-height: 100vh;
  padding: 0 15px;
  background: url("~@/assets/img/main-page-bg.jpg") no-repeat;
  // 修改背景图显示方式，确保完整显示
  background-size: 100% 100%;  // 改为 100% 100%，强制拉伸填满
  // 或者使用 contain 保持完整但可能有留白
  // background-size: contain;
  // background-position: center;
  // background-repeat: no-repeat;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .main-nav {
    display: flex;
    justify-content: space-between;
    margin-top: auto;
    margin-bottom: 110px;
    gap: 10px;

    .main-nav-item {
      flex: 1;
      min-width: 0;

      .sub-item {
        width: 100%;
        border-radius: 3px;
        background: #fff;
        box-sizing: border-box;
        box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.2);
        overflow: hidden;
        cursor: pointer;

        .img-group {
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          width: 100%;
          height: calc(100% - 57px);

          &:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0px;
            height: 30px;
            width: 100%;
            background: linear-gradient(to bottom,
                rgba(255, 255, 255, 0.1),
                rgba(254, 0, 0, 0.2));
          }

          .icon {
            position: absolute;
            bottom: 10px;
            right: 8px;
            width: 25px;
            height: 25px;
          }
        }

        .sub-tit-wrap {
          font-size: 14px;
          padding: 8px;
          position: relative;
          z-index: 2;

          .en {
            display: block;
            margin-top: 3px;
            color: #ccc;
            font-size: 12px;
          }
        }

        &.sign-up {
          height: 120px;

          .img-group {
            height: calc(100% - 45px);

            .img {
              position: absolute;
              bottom: 0;
              left: 8px;
              width: 60px;
            }

            .icon {
              position: absolute;
              bottom: 10px;
              right: 8px;
              width: 25px;
              height: 25px;
            }
          }
        }

        &.send {
          margin-top: 10px;
          height: 200px;

          .img-group {
            .img {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100px;
            }

            .icon {
              position: absolute;
              bottom: 10px;
              right: 8px;
              width: 25px;
              height: 25px;
            }
          }
        }

        &.pay {
          height: 120px;

          .img-group {
            .img {
              position: absolute;
              bottom: 0px;
              left: 0;
            }

            .icon {
              position: absolute;
              top: -50px;
              right: 8px;
              width: 25px;
              height: 25px;
            }
          }
        }

        &.hy {
          height: 60px;
          margin-top: 10px;

          .icon {
            position: absolute;
            top: -50px;
            right: 8px;
            width: 25px;
            height: 25px;
          }
        }

        &.bm,
        &.dc {
          height: 60px;
          margin-top: 10px;

          .img-group {
            height: calc(100% - 45px);
          }

          .icon {
            position: absolute;
            top: -40px;
            right: 8px;
            width: 25px;
            height: 25px;
          }
        }

        &.msg {
          height: 190px;

          .img-group {
            .img {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100px;
            }

            .icon {
              position: absolute;
              top: -50px;
              right: 8px;
              width: 25px;
              height: 25px;
            }
          }
        }

        &.qd {
          height: 70px;
          margin-top: 10px;

          .icon {
            position: absolute;
            top: -50px;
            right: 8px;
            width: 25px;
            height: 25px;
          }
        }

        &.out {
          height: 50px;
          margin-top: 10px;

          .img-group {
            height: calc(100% - 45px);
          }

          .icon {
            position: absolute;
            top: -40px;
            right: 8px;
            width: 25px;
            height: 25px;
          }
        }
      }
    }

    .main-nav-item:nth-child(1) {
      flex: 32%;
    }

    .main-nav-item:nth-child(2) {
      flex: 32%;
      margin: 0 10px;
    }

    .main-nav-item:nth-child(3) {
      flex: 36%;
    }
  }
}

// 不同屏幕比例适配背景图
@media (min-aspect-ratio: 1/1) {
  .main-page {
    background-size: cover;
    background-position: center;
  }
}

// 小屏幕适配 - 保持三列布局，只缩放比例
@media (max-width: 768px) {
  .main-page {
    padding: 0 10px;

    .main-nav {
      gap: 6px;
      margin-bottom: 60px;

      .main-nav-item:nth-child(2) {
        margin: 0 6px;
      }

      .sub-item {
        .sub-tit-wrap {
          font-size: 11px;
          padding: 6px;

          .en {
            font-size: 9px;
          }
        }

        .img-group .icon {
          width: 18px;
          height: 18px;
        }

        &.sign-up {
          height: 90px;

          .img-group .img {
            width: 45px;
          }
        }

        &.send {
          height: 150px;

          .img-group .img {
            width: 75px;
          }
        }

        &.pay {
          height: 90px;
        }

        &.msg {
          height: 140px;

          .img-group .img {
            width: 75px;
          }
        }

        &.hy, &.bm, &.dc {
          height: 45px;
        }

        &.qd {
          height: 52px;
        }

        &.out {
          height: 38px;
        }
      }
    }
  }
}

// 超小屏幕
@media (max-width: 480px) {
  .main-page {
    padding: 0 6px;

    .main-nav {
      gap: 4px;
      margin-bottom: 40px;

      .main-nav-item:nth-child(2) {
        margin: 0 4px;
      }

      .sub-item {
        .sub-tit-wrap {
          font-size: 10px;
          padding: 4px;

          .en {
            font-size: 8px;
          }
        }

        .img-group .icon {
          width: 14px;
          height: 14px;
          right: 4px;
        }

        &.sign-up {
          height: 70px;

          .img-group .img {
            width: 35px;
            left: 4px;
          }
        }

        &.send {
          height: 110px;
          margin-top: 6px;

          .img-group .img {
            width: 55px;
          }
        }

        &.pay {
          height: 70px;
        }

        &.msg {
          height: 100px;

          .img-group .img {
            width: 55px;
          }
        }

        &.hy, &.bm, &.dc {
          height: 35px;
          margin-top: 6px;
        }

        &.qd {
          height: 40px;
          margin-top: 6px;
        }

        &.out {
          height: 30px;
          margin-top: 6px;
        }
      }
    }
  }
}

// 横屏适配
@media (orientation: landscape) and (max-height: 500px) {
  .main-page {
    .main-nav {
      margin-bottom: 20px;
    }
  }
}

// 安全区域适配
@supports (padding: max(0px)) {
  .main-page {
    padding-left: max(15px, env(safe-area-inset-left));
    padding-right: max(15px, env(safe-area-inset-right));
    
    .main-nav {
      margin-bottom: max(110px, calc(110px + env(safe-area-inset-bottom)));
    }
  }
}
</style>